import { filterConstants } from "../../constants";
import { IQueryStringNavLinks } from "../../interfaces-and-types";
import { View } from "./View";

export interface IHomeViewProps {
  monthlyOrYearlyQueryStringTabs: IQueryStringNavLinks;
}

export const Home = () => {
  const monthlyOrYearlyQueryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.monthlyOrYearlyStatusKey,
    options: [
      {
        key: "Monthly",
        value: "mnth",
      },
      {
        key: "Yearly",
        value: "yr",
      },
    ],
  };

  return (
    <View monthlyOrYearlyQueryStringTabs={monthlyOrYearlyQueryStringTabs} />
  );
};
